import AddressDetails from './address-details';

export default AddressDetails;
